module.exports = __webpack_public_path__ + "img/d91ebc6.png";